export function isProduction(): boolean {
  return process.env.ENV === "production";
}

export function isStaging(): boolean {
  return process.env.ENV === "staging";
}

export function isProductionOrStaging(): boolean {
  return isProduction() || isStaging();
}

export function isBlacksmithRunner(runnerLabel: string): boolean {
  if (isProduction()) {
    return runnerLabel.startsWith("blacksmith");
  }

  if (isStaging()) {
    return runnerLabel.startsWith("blacksmith-staging");
  }

  // Default to allowing all runners in development
  return true;
}
